import { useState, useEffect } from "react";
// material
import { Box, Card, Container } from "@mui/material";
import Label from "../Label";
// components
import Scrollbar from "../table/Scrollbar";
import TableView from "../Table";
import { parseDateTime } from "../../utils/tableFunctions";
import {
  // getHistoryAccountFilterConditions,
  getMerchantUserHistory,
  // getTransactionCSV,
} from "../../services/services";

import { SingleSelectType } from "../table/Filter";
import CircularLoader from "../circularLoader";
import CommonDialog from "../CustomDialog";
import HeaderHelpPage from "../HeaderHelpPage";
import AccountDetails from "../../pages/details/admin/MerchantUserDetails";
import { pageNumber, rowsPerPage } from "../../utils/constants";

// ----------------------------------------------------------------------

export default function HistoryAccount() {
  const [historyAccount, setHistoryAccount] = useState();
  const [loaded, setLoaded] = useState(false);
  const [tableData, setTableData] = useState();
  const [selected, setSelected] = useState([]);
  const [filterName, setFilterName] = useState();
  const [fParams, setFParams] = useState({});
  const [itemId, setItemId] = useState(null);

  const [pagination, setPagination] = useState({
    page: pageNumber,
    page_size: rowsPerPage,
  });

  // ------------------ filterStuffies --------------------//
  const [reset, setReset] = useState(false);
  const [fLoaded, setFLoaded] = useState(false);
  const [historyAccountFilter, setHistoryAccountFilter] = useState({});

  const filterComponents = () => {
    if (fLoaded && Object.keys(fParams).length > 0) {
      return (
        <Box sx={{ mt: 3 }}>
          <SingleSelectType
            options={fParams.group.map((grp) => grp)}
            selected={historyAccountFilter}
            setSelected={setHistoryAccountFilter}
            label="Group"
            param={"group"}
            reset={reset}
          />
          <SingleSelectType
            id="true"
            options={[
              { name: "Approved", id: true },
              { name: "Not Approved", id: false },
            ]}
            selected={historyAccountFilter}
            setSelected={setHistoryAccountFilter}
            label="Approved"
            param={"is_approved"}
            reset={reset}
          />
          <SingleSelectType
            options={fParams.email.map((email) => email)}
            selected={historyAccountFilter}
            setSelected={setHistoryAccountFilter}
            label="Email"
            param={"email"}
            reset={reset}
          />
          <SingleSelectType
            options={["Add", "Remove", "Update"]}
            selected={historyAccountFilter}
            setSelected={setHistoryAccountFilter}
            label="Action"
            param={"action"}
            reset={reset}
          />
        </Box>
      );
    }
  };

  const onFilterSubmit = () => {
    queryPage({
      page: 1,
      page_size: pagination.page_size,
    });
  };

  // ------------------ end of filter stuffies --------------------//

  useEffect(() => {
    if (reset) setReset(false);
  }, [reset]);

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const queryPage = (queryParams) => {
    setLoaded(false);
    getMerchantUserHistory({
      setResponse: setHistoryAccount,
      filter: {},
      setLoaded: setLoaded,
      queryParams: queryParams,
    });
    setPagination(queryParams);
  };

  useEffect(() => {
    queryPage(pagination);
  }, []);

  const formatData = (input) => {
    let tableData = [];
    if (!input) return tableData;
    input.forEach(
      ({
        action,
        created_at,
        email,
        business_entity,
        merchant_group,
        id,
        is_approved,
      }) => {
        tableData.push({
          id: id,
          email: email,
          action: action === "Remove" ? "Deactivate" : action === "Restore" ? "Activate" : action,
          created_on: parseDateTime(created_at),
          business_entity: business_entity?.business_name,
          merchant_group: merchant_group?.name,
          approved: (
            <>
              <Label variant="ghost" color={is_approved ? "success" : "error"}>
                {is_approved ? "YES" : "NO"}
              </Label>
            </>
          ),
        });
      }
    );
    return tableData;
  };

  useEffect(() => {
    if (historyAccount) {
      setTableData(formatData(historyAccount.results || []));
    }
  }, [historyAccount]);

  return (
    <Container style={{ paddingLeft: 0, paddingRight: 0 }}>
      {loaded ? (
        <Card>
          {/* <ListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            filter={true}
            loaded={loaded}
            filterFunction={filterComponents}
            onFilterSubmit={onFilterSubmit}
            setReset={setReset}
            csv={false}
          /> */}
          <Scrollbar>
            <TableView
              rows={tableData}
              link={`/3/app/merchant-user-details~id~?action=true`}
              onSelectItem={(id) => setItemId(id)}
              count={historyAccount?.count || 0}
              query={filterName}
              data={historyAccount?.results || []}
              pagination={pagination}
              getNext={queryPage}
            />
          </Scrollbar>
        </Card>
      ) : (
        <CircularLoader />
      )}

      {itemId && (
        <CommonDialog
          title={<HeaderHelpPage title="Merchant User Details" variant="h5" mb={0} />}
          onClose={() => setItemId(null)}
        >
          <AccountDetails itemId={itemId} isViewHistory />
        </CommonDialog>
      )}
    </Container>
  );
}
